module.exports = "<div class=\"store-credit-line-items\"> <div class=\"order-totals-line-item__title\">Gift Cards:</div> <div ng-repeat=\"storeCredit in $ctrl.storeCreditInfo.items\"> <gift-card-line-item applied-store-credit=\"storeCredit\"> </gift-card-line-item> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/orderSummary/components/orderTotals/storeCreditLineItems.html
// module id = 829
// module chunks = 0